export default {
    title: "Pesquisa Enviada",
    header: "@:views.survey.submitted.title",
    message: "Obrigado pelo seu feedback.",
}